<template>
  <el-dialog
    class="member-contact-dialog"
    :visible="visible"
    :before-close="handleClose"
    append-to-body
  >
    <div slot="title" class="contact-title">
      <img :src="headerIcon" alt="" />
      <strong>联系客服</strong>
    </div>
    <div class="contact-content">
      <p>尊敬的用户，咨询购买请联系我们！</p>
      <div class="contact-qr-wrap">
        <img
          v-if="displayQrCode"
          :src="displayQrCode"
          alt="客服微信二维码"
        />
        <div v-else class="contact-qr-placeholder">
          <i class="el-icon-picture-outline" />
          <span>待配置客服二维码</span>
        </div>
      </div>
      <span class="contact-tip">微信扫码添加服务顾问</span>
    </div>
  </el-dialog>
</template>

<script>
export default {
  name: "MemberContactDialog",
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    qrCode: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      headerIcon: require("@/assets/imgs/payment/connect-header-icon.png"),
      defaultQrCode: require("@/assets/imgs/payment/connect-qrcode.jpg"),
    };
  },
  computed: {
    displayQrCode() {
      return this.qrCode || this.defaultQrCode;
    },
  },
  methods: {
    handleClose() {
      this.$emit("update:visible", false);
      this.$emit("close");
    },
  },
};
</script>

<style lang="less" scoped>
.member-contact-dialog {
  /deep/ .el-dialog {
    width: 540px;
    height: 340px;
    margin: 0 !important;
    position: absolute;
    top: 50%;
    left: 50%;
    border-radius: 12px;
    overflow: hidden;
    transform: translate(-50%, -50%);
    background: #fff url(~@/assets/imgs/payment/connect-bg.png) no-repeat center /
      100% 100%;
    box-shadow: 0 18px 52px rgba(22, 41, 78, 0.2);
  }
  /deep/ .el-dialog__header {
    height: 58px;
    padding: 0 24px;
    border-bottom: 1px solid #edf0f5;
    box-sizing: border-box;
  }
  /deep/ .el-dialog__headerbtn {
    top: 21px;
    right: 24px;
    .el-dialog__close {
      color: #9399a7;
      font-size: 18px;
    }
  }
  /deep/ .el-dialog__body {
    padding: 0;
  }
}
.contact-title {
  height: 58px;
  display: flex;
  align-items: center;
  gap: 8px;
  color: #202938;
  img {
    width: 24px;
    height: 24px;
  }
  strong {
    font-size: 16px;
  }
}
.contact-content {
  padding: 12px 24px 0;
  color: #60697a;
}
.contact-content p {
  margin: 0;
  font-size: 13px;
  line-height: 20px;
}
.contact-qr-wrap {
  width: 158px;
  height: 158px;
  margin: 8px auto 0;
  padding: 8px;
  border-radius: 6px;
  box-sizing: border-box;
  background: #fff;
  box-shadow: 0 5px 18px rgba(39, 67, 112, 0.1);
}
.contact-qr-wrap > img {
  width: 100%;
  height: 100%;
  object-fit: contain;
}
.contact-qr-placeholder {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 8px;
  background: #f5f7fa;
  color: #a3a9b5;
  font-size: 11px;
  i {
    font-size: 30px;
  }
}
.contact-tip {
  display: block;
  margin-top: 8px;
  color: #adb2bd;
  font-size: 11px;
  line-height: 18px;
  text-align: center;
}
</style>
